/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { Fragment, useEffect } from 'react'
import Config from '../config'
import { OmnitechApi, OmnitechApiV1 } from '../api'
import { useAuth } from '../auth'
import { useI18n } from '../i18n'
import withComposedProvider from './with-composed-provider'

function OmnitechApp ({ config, currentLocale, children }) {
  const { auth = {} } = useAuth()
  const { changeLanguage } = useI18n()
  const { authToken, deviceUdid } = auth

  // set the current locale of the app
  useEffect(() => {
    // set config
    Config.set(config)

    changeLanguage(currentLocale)
  }, [])

  useEffect(() => {
    // set the http header for authorization
    // TODO: use different header for different chanel
    OmnitechApi.setAuthorizationHeader({ authToken, deviceUdid })
    OmnitechApiV1.setAuthorizationHeader({ authToken, deviceUdid })
  }, [authToken, deviceUdid])

  return <Fragment>{children}</Fragment>
}

export default OmnitechApp
